import * as icons from 'react-bootstrap-icons';

export const SettingTabs = [
    {
        title: 'زمان‌ها',
        icon: <icons.Clock />,
        index: 1,
        active: true,
        link: '/dashboard/setting/times',
        acin: [4, 1],
    },{
        title: 'پیام‌رسان',
        icon: <icons.ChatLeft />,
        index: 5,
        active: true,
        link: '/dashboard/setting/message',
        acin: [4, 5],
    },{
        title: 'کارت‌خوان',
        icon: <icons.Bank />,
        index: 6,
        active: true,
        link: '/dashboard/setting/bank',
        acin: [4, 6],
    },{
        title: 'پزشکان',
        icon: <icons.PersonWorkspace />,
        index: 2,
        active: true,
        link: '/dashboard/setting/doctors',
        acin: [4, 2],
    },{
        title: 'نوع‌ها',
        icon: <icons.Fingerprint />,
        index: 3,
        active: true,
        link: '/dashboard/setting/types',
        acin: [4, 3],
    },{
        title: 'وضعیت‌ها',
        icon: <icons.Back />,
        index: 4,
        active: true,
        link: '/dashboard/setting/statuses',
        acin: [4, 4],
    },
]